import React, { Component } from 'react';
import TwitterService from '../../../services/twitter';

import './twitter-instagram-messaging.css';

class TwitterInstagramMessaging extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isError: false,
      isLoading: true,
      isFetched: false
    };
  }

  getMessages = () => {
    this.setState({
      isFetched: true,
    });

    TwitterService.getTwitterMessagesForInstagram()    
      .then(({ messagesByUserID, lastTimesByBot }) => {
        this.setState({ 
          messagesByUserID,
          lastTimesByBot,
          responses: [],
          isLoading: false,
        });
      })
      .catch((err) => {
        const errorMessage = err && err.response && err.response.data;
        this.setState({ isError: true, errorMessage: errorMessage });
      });
  }

  // getOnChange = (idStr) => {
  //   return (event) => {
  //     this.setState((prevState) => {
  //       return {
  //         candidates: prevState.candidates.map(candidate => {
  //           const additionals = {};

  //           if (candidate.idStr === idStr) {
  //             additionals.approved = !candidate.approved;
  //           }

  //           return {
  //             ...candidate,
  //             ...additionals
  //           };
  //         })
  //       }
  //     })
  //   }
  // }

  getImg = (imgUrl) => {
    if (!imgUrl) return '';
    return <img src={imgUrl} height='70px'/>;
  }

  onSave = () => {
    this.setState({
      isLoading: true,
    });
    
    TwitterService.saveTwitterMessagesResponsesForInstagram({
      responses: this.state.responses,
      lastTimesByBot: this.state.lastTimesByBot
    })    
      .then(() => {
        window.location.href = 'https://dormoshe.io';
      })
      .catch((err) => {
        const errorMessage = err && err.response && err.response.data;
        this.setState({ isError: true, errorMessage: errorMessage });
      });
  }

  getMessageOnChange = (userId, botID) => {
    return (event) => {
      const newValue = event.target.value;
      if (!newValue && this.state.responses.hasOwnProperty(userId)) {
        
        this.setState((prevState) => {
          const updatedResponses = this.state.responses;
          delete updatedResponses[userId];

          return {
            responses: updatedResponses
          };
        });

        return;
      }

      this.setState((prevState) => {
        return {
          responses: {
            ...prevState.responses,
            [userId]: {
              message: newValue,
              botID
            }
          },
        };
      });
    };
  };

  getOptionalResponses = () => [
    `Hey,
Thanks for responding :)
Do you have an Instagram account?`,
    `What's your Instagram profile link?`,
    `My pleasure!
Thanks for responding :)
Keep reading.
Do you have an Instagram account?`,
    `My pleasure! 
Thanks for responding.
Followed you!
Please check :)`,
`Thanks for responding.
Followed you!
Please check :)`,
`Awesome. Followed you!
Please check :)`,
`Really appreciated :)
Thanks!`,
`Thanks for responding!`,
`Thanks!`
  ];
    
  render() {
    let body = 'Processing...';
    //console.log(this.responses);

    if (this.state && !this.state.isFetched) {
      body = <div><input type='button' value='Fetch' onClick={this.getMessages}/></div>
    }

    if (this.state && this.state.messagesByUserID && !this.state.isLoading && this.state.isFetched) {
      body = (
        <div>  
          <input type='button' className='save-button' value='Save' onClick={this.onSave}/>

          <section>
            {
              Object.entries(this.state.messagesByUserID).map(([userId, messages], i) => 
                <div key={userId}>
                  <div><label>{i + 1} out of {Object.keys(this.state.messagesByUserID).length}</label></div>
                  
                  <div>{messages[0].botID}</div>
                  <div>
                    <ul>
                      {
                        messages.map(({ text, urls }) => {
                          let relevantUrl = (urls || []).find(url => url.indexOf('instagram') !== -1);
                          const shtrudelSplit = text.split('@');
                          const usernameMentioningUrl = shtrudelSplit.length > 1 ? `https://www.instagram.com/${shtrudelSplit[1].split(' ')[0]}` : '';
                          relevantUrl = relevantUrl || usernameMentioningUrl;

                          return (
                            <li>
                              {text}
                              { relevantUrl ? (<b>Insta?: <a style={{cursor: "point", backgroundColor: 'pink'}} href={relevantUrl}>{relevantUrl}</a></b>) : '' }
                              
                              { relevantUrl && <input type='button' className='open-insta-button' value='Open Insta' onClick={() => window.open(relevantUrl, '_blank')}/> }
                            </li>
                          );
                        })
                      }
                    </ul>
                  </div>
                  <div>
                    <textarea 
                      className='long-input'
                      required
                      value={this.state.responses[userId] ? this.state.responses[userId].message : ''} 
                      onChange={this.getMessageOnChange(userId, messages[0].botID)}
                      rows='5' />
                    <div>
                      { 
                        this.getOptionalResponses().map(
                          response => <input type='button' value={response} onClick={() => {
                            this.getMessageOnChange(userId, messages[0].botID)({
                              target: {
                                value: response
                              }
                            })
                          }}/>
                        )
                      }
                    </div>                      
                  </div>
                  {/* { this.getImg(candidate.img) } */}

                  {/* {
                    generalFields.map(field => candidate[field]).filter(x=>x).join(' | ')
                  } */}
                <hr/>
              </div>
              )
            }
          </section>

          <input type='button' className='save-button' value='Save' onClick={this.onSave}/>
        </div>
      );
    }

    if (this.state.isError) {
      body = 'Error';
      body += this.state.errorMessage ? `: ${this.state.errorMessage}` : '';
    }

    return (
      <section className='regular-page twitter-instagram-messaging'>
        {body}
      </section>
    );
  }
}

export default TwitterInstagramMessaging;
